
import { defineComponent, PropType } from '@vue/composition-api';

import PartialPaymentPopup from '@ve/components/partialPayment/partialPaymentPopup/desktop/PartialPaymentPopup.vue';
import { PartialPaymentTourProduct } from '@ve/components/partialPayment/common/types/PartialPaymentTourProduct';

import usePartialPaymentBannerForProductCard
    from '@ve/components/partialPayment/common/use/usePartialPaymentBannerForProductCard';
import usePartialPaymentPopupRef from '@ve/components/partialPayment/common/use/usePartialPaymentPopupRef';
import useCashbackPartialPaymentBannerForProductCard from '../common/use/useCashbackPartialPaymentBannerForProductCard';

export default defineComponent({
    name: 'CashbackPartialPaymentBannerForProductCard',
    components: { PartialPaymentPopup },
    props: {
        countryName: {
            type: String,
            default: '',
        },
        products: {
            type: Array as PropType<PartialPaymentTourProduct[]>,
            default: () => ([]),
        },
        productType: {
            type: String as PropType<'hotelOffer' | 'tourOffer'>,
            default: 'tourOffer',
        },
    },
    setup(props) {
        const {
            minPriceText,
            minPercentText,
        } = usePartialPaymentBannerForProductCard(props);

        const {
            productTypeLabelText,
        } = useCashbackPartialPaymentBannerForProductCard(props);

        const {
            openPopup,
            partialPaymentPopupRef,
        } = usePartialPaymentPopupRef();

        return {
            minPriceText,
            minPercentText,
            openPopup,
            partialPaymentPopupRef,
            productTypeLabelText,
        };
    },
});
